import { render, staticRenderFns } from "./ModalComplemento.vue?vue&type=template&id=32462930"
import script from "./ModalComplemento.vue?vue&type=script&lang=js"
export * from "./ModalComplemento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports